import React from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import { wordpressImgToImgixURL } from 'Utilities';

import styles from './ContentSection.scss';

export type ContentSectionThemeProps = 'black' | 'blue' | 'white' | 'primary-light-yellow';

type Props = {
  className?: ClassNameType;
  contentBody: string;
  imgAlt?: string;
  imgSrc?: React.ReactNode;
  reverse?: boolean;
  theme?: ContentSectionThemeProps;
  title: string;
};

const ContentSection = ({
  className,
  contentBody,
  imgAlt = '',
  imgSrc = '',
  reverse = false,
  theme = 'white',
  title,
}: Props) => {
  const generateImg = (imgSource: Props['imgSrc']) => {
    if (!imgSource) {
      return null;
    }

    if (React.isValidElement(imgSource)) {
      return imgSource;
    }

    return (
      <img
        alt={imgAlt}
        height='440'
        loading='lazy'
        src={`${wordpressImgToImgixURL(imgSource)}&w=1024`}
        width='440'
      />
    );
  };

  return (
    <div className={cx(styles.component, styles[theme], className, { [styles.reverse]: reverse })}>
      {generateImg(imgSrc)}
      <div className={cx(styles.contentArea, { [styles.noImage]: !imgSrc })}>
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: contentBody }} />
      </div>
    </div>
  );
};

export default ContentSection;
